import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'
import { ActiveScenarioFilters } from '../utils/hazardScenarioFilters.utils'

/**
 * Atom family scoped per layerId.
 * Holds the active scenario filter selections for a given hazard layer.
 * Consumed by: HazardScenarioFilters, useHazardScenarioFilters, ActiveFiltersBar.
 */
export const scenarioFiltersAtomFamily = atomFamily((_layerId: string) =>
  atom<ActiveScenarioFilters>({}),
)
